import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Icon.scss';

const Icon = ({ className, horizontal, ...props }) =>
    <i
        {...props}
        className={classnames(
            styles.icon,
            className,
            { [styles.horizontal]: horizontal },
            `icon ${props.name}`
        )}
    />;

Icon.propTypes = {
    horizontal: PropTypes.bool,
    name: PropTypes.string,
    src: function (props, propName) {
        if (Boolean(props.name) === true && Boolean(props[propName]) === true) {
            return new Error('Please provide only "src" or "name", not both');
        } else if (Boolean(props.name) === false && Boolean(props[propName]) === false) {
            return new Error('Please provide one of "src" or "name"');
        }
    }
};

Icon.defaultProps = {
    horizontal: false
};

export default Icon;
